module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rkgnZv/tc-custom/9781488002311.jpg?1699984821658",
      "alt": "This image is the cover for the book Baby and a Betrothal, Crimson, Colorado"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Baby and a Betrothal, Crimson, Colorado\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From a "), _c('i', [_vm._v("USA Today–")]), _vm._v("bestselling author, when best friends become lovers with a surprise baby on the way, their friendship turns to true love.")]), _c('br'), _c('br'), _vm._v("WANTED: HUSBAND & DADDY"), _c('br'), _c('br'), _vm._v("Serious Candidates Only!"), _c('br'), _c('br'), _vm._v("Katie Garrity is proud of her work at her Life is Sweet bakery, but it’s high time she showed the town of Crimson that she’s more than just “The Cupcake Lady.” She wants to be “Mrs.” and “Mommy” so badly she can’t stand it! But in the small mountain town, the pickings are slim . . . until the one who got away returns."), _c('br'), _c('br'), _vm._v("As a forest ranger, Noah loves protecting the places and people he loves—he just can’t commit to forever. Katie has been his best friend since high school, but when did she turn into such a lovely woman? And is that desire he feels? Still, Crimson holds too many memories, and Katie wants things Noah can’t give. But after one explosive night, it just may be too late. Only nine months will tell . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michelle Major\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("USA Today bestselling author Michelle Major loves stories of new beginnings, second chances and always a happily ever after. An avid hiker and avoider of housework, she lives in the shadow of the Rocky Mountains with her husband, two teenagers and a menagerie of spoiled furbabies. Connect with her at www.michellemajor.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0